var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarNumberOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 4.12354H4.5C3.25736 4.12354 2.25 5.13089 2.25 6.37354V19.8735C2.25 21.1162 3.25736 22.1235 4.5 22.1235H19.5C20.7426 22.1235 21.75 21.1162 21.75 19.8735V6.37354C21.75 5.13089 20.7426 4.12354 19.5 4.12354Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.62354V4.12354M18 2.62354V4.12354M21.75 7.87354H2.25M14.25 12.561L16.2853 11.061H16.5V18.936M8.99391 14.7468C9.42094 14.7468 10.2028 14.5462 10.7152 14.0217C10.883 13.8542 11.0156 13.6549 11.1052 13.4355C11.1948 13.216 11.2396 12.9809 11.2369 12.7438C11.2369 11.5195 10.178 10.8735 8.99203 10.8735C7.98891 10.8735 7.42078 11.4178 7.21781 11.7609M6.98438 17.9123C7.21313 18.2999 7.90828 19.1235 9.04125 19.1235C10.3814 19.1235 11.4844 18.3763 11.4844 17.0695C11.4844 16.4779 11.3128 15.9445 10.9416 15.5662C10.3622 14.9737 9.47672 14.7468 8.99391 14.7468",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarNumberOutline);
export default __webpack_public_path__ + "static/media/calendar-number-outline.03be5febb40af9f86ab2f95ae4d2df67.svg";
export { ForwardRef as ReactComponent };